module.exports = __webpack_public_path__ + "files/acb4d1bda6bf5ed613d3a7fb154fd601.png";